var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClasses},[_c('navigation',{attrs:{"headings":_vm.tabHeadings,"active":_vm.activeTab,"nav-classes":_vm.finalNavClasses},on:{"click":_vm.changeActiveTab}}),_vm._v(" "),_c('tab-content-wrapper',{attrs:{"tabs":_vm.tabs,"active-tab":_vm.activeTab}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2b26a5c","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Tabs/Tabs.vue
// module id = 2021
// module chunks = 0